import React, { memo } from 'react';
import classNames from 'classnames';
import { Box, Typography, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

import InformationCard, { IInformationCardProps } from '../../../../../components/InformationCard/InformationCard';
import locationImage from '../../../../../assets/images/location.svg';
import OriginalAddress from '../../OriginalAddress';
import { getRecipient } from '../../../store/recipient.selectors';
import VerifiedAddress from '../../VerifiedAddress';
import { getShipping } from '../../../store/giftFlow/giftFlow.selectors';

import useStyles from './shippingAddress.styles';

export interface IShippingAddressCardProps {
  isPhysical: boolean;
  informationCardProps?: IInformationCardProps;
}

const ShippingAddressCard = ({ isPhysical, informationCardProps = {} }: IShippingAddressCardProps) => {
  const classes = useStyles();
  const { palette } = useTheme();

  const recipient = useSelector(getRecipient);
  const { address: originalAddress, verifiedAddress, isAddressVerified } = useSelector(getShipping) || {};

  return (
    <Box maxWidth={[320, 430]} mx="auto">
      <InformationCard
        title="Shipping address"
        borderColor={palette.grey.timberWolf}
        minHeight={120}
        data-testid="shippingAddressDetails"
        {...informationCardProps}
      >
        <Box width={1} display="flex" justifyContent="flex-start" alignItems="flex-start">
          <img className={classes.image} src={locationImage} alt="Meeting" />
          <Box textAlign="left" maxWidth={200}>
            <Typography className={classNames('Body-Regular-Left-Static-Bold', classes.textWrap)}>
              {recipient?.firstName} {recipient?.lastName}
            </Typography>
            {isPhysical && !isAddressVerified && originalAddress && <OriginalAddress address={originalAddress} />}
            {isPhysical && isAddressVerified && verifiedAddress && <VerifiedAddress address={verifiedAddress} />}
            {!isPhysical && <Typography className="Body-Regular-Left-Static-Bold">{recipient?.email}</Typography>}
          </Box>
        </Box>
      </InformationCard>
    </Box>
  );
};

export default memo(ShippingAddressCard);
